import React from 'react';
import {
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  Box,
} from '@mui/material';
import {
  CompareArrows as CompareIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import AdminLayout from '../../../layouts/AdminLayout';

const reportCards = [
  {
    title: 'Season Comparison',
    description: 'Compare player rosters between two seasons to see retention, churn, role changes, and new members.',
    icon: <CompareIcon sx={{ fontSize: 40 }} />,
    path: '/admin/reports/season-comparison',
  },
];

const ReportsHubPage = () => {
  return (
    <AdminLayout>
      <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, sm: 3 }, py: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight={700}>
          Reports
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Analytics and insights for your organization.
        </Typography>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' }, gap: 3 }}>
          {reportCards.map((card) => (
            <Card key={card.path} variant="outlined" sx={{ display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flex: 1 }}>
                <Box sx={{ color: 'primary.main', mb: 2 }}>
                  {card.icon}
                </Box>
                <Typography variant="h6" gutterBottom fontWeight={600}>
                  {card.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {card.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ px: 2, pb: 2 }}>
                <Button
                  component={Link}
                  to={card.path}
                  variant="contained"
                  size="small"
                >
                  View Report
                </Button>
              </CardActions>
            </Card>
          ))}
        </Box>
      </Box>
    </AdminLayout>
  );
};

export default ReportsHubPage;
